import React, { useCallback } from 'react';
import { useLazyQuery } from 'apollo-3';
import urlJoin from 'url-join';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { onlineCourseByCourseCode } from 'GraphQL/query/Product.query';
import { useMyCourseData } from 'Domain/MyCourseData';
import { useConfig } from 'Context/ConfigContext';
import { Flex, Text, SvgIcon, ButtonFilled } from 'Components/Base';

import { getStoreApolloClient } from '../../../GraphQL';

const storeApolloClient = getStoreApolloClient();
const ExitPreviewClassroomButton = ({ isHideText, onExitClassroomClick, ...props }) => {
  const { courseCode } = useMyCourseData();
  const { onlineCourseDetailUrl } = useConfig();
  const { t } = useTranslation('classroom');

  const [getOnlineCourseByCourseCode, { called, data: OnlineCourseData, loading, error }] =
    useLazyQuery(onlineCourseByCourseCode, {
      variables: { courseCode },
      client: storeApolloClient,
    });

  const handleExitClassroomButton = useCallback(() => {
    onExitClassroomClick();
    getOnlineCourseByCourseCode();
  }, [onExitClassroomClick, getOnlineCourseByCourseCode]);

  if (called && OnlineCourseData) {
    window.location = urlJoin(
      onlineCourseDetailUrl,
      OnlineCourseData?.sfFoProductGetOnlineCourseByCourseCode.permalink
    );
  }

  return (
    <ButtonFilled
      py={4}
      color={'white'}
      border={0}
      width="100%"
      onClick={handleExitClassroomButton}
      {...props}
    >
      <Flex alignItems="center">
        <Text lineHeight={0} mr={5} color="primary">
          <SvgIcon size={24} icon={SvgIcon.ICON_LIST.APPS} />
        </Text>
        {!isHideText && (
          <Text fontWeight="medium" fontFamily="content">
            {t('COURSE_PREVIEW.EXIT_CLASSROOM')}
          </Text>
        )}
      </Flex>
    </ButtonFilled>
  );
};

ExitPreviewClassroomButton.propTypes = {
  isHideText: PropTypes.bool,
  onExitClassroomClick: PropTypes.func,
};

ExitPreviewClassroomButton.defaultProps = {
  onExitClassroomClick: () => {},
};

export default ExitPreviewClassroomButton;
